// import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
import './index.css';
import { MainContextProvider } from './hooks/useMainContext';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'react-oidc-context';
import {
    AUTHORITY_URL,
    CLIENT_ID,
    RESPONSE_TYPE,
    getCallbackUri,
} from './__common/env';
import AntdConfigProvider from './hooks/AntdConfigProvider';

const cognitoAuthConfig = {
    authority: AUTHORITY_URL,
    client_id: CLIENT_ID,
    redirect_uri: getCallbackUri(),
    response_type: RESPONSE_TYPE,
    scope: 'email openid phone profile',
    automaticSilentRenew: true,
    loadUserInfo: true,
};

const root = createRoot(document.getElementById('root'));
root.render(
    <AuthProvider {...cognitoAuthConfig}>
        <AntdConfigProvider>
            <MainContextProvider>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </MainContextProvider>
        </AntdConfigProvider>
    </AuthProvider>,
);
